import React from "react";
import { Modal, Form, Input, Card } from "antd";
import Button from "./button";
import colors from "../../share/constants/constants";
import { approveBusiness } from "../../api/business";
import Close from "./../../assets/icons/close.svg";

const YupupCutModal = ({ onCancel, onOk, data, text, title, promo }) => {
  const [form] = Form.useForm();

  const onFinish = async (value) => {
    const payload = {
      cutFee: +value?.confirmCut >= 0 ? +value?.confirmCut : data?.business?.cutFee,
      subServiceCutFee:
      +value?.confirmSubServiceCut >= 0 ? +value?.confirmSubServiceCut : data?.business?.subServiceCutFee,
    };
    const res = await approveBusiness(data?.business?._id, payload);
    if (res) {
      onCancel();
    }
  };

  const preventNegativeKey = (e) => {
    const blockedKeys = ["-", "e", "E", "+"];
    if (blockedKeys.includes(e.key)) {
      e.preventDefault();
    }
  };

  const preventNegativePaste = (e) => {
    const paste = (e.clipboardData || window.clipboardData).getData("text");
    if (/^-/.test(paste) || /[eE+]/.test(paste)) {
      e.preventDefault();
    }
  };

  const getNonNegativeFromEvent = (e) => {
    const raw = e?.target?.value ?? "";
    let sanitized = String(raw).replace(/[^0-9.]/g, "");
    if (sanitized.startsWith(".")) sanitized = `0${sanitized}`;
    return sanitized;
  };

  const validatePercentage = (_, value) => {
    if (value === '' || value === undefined) {
      return Promise.resolve();
    }
    const numValue = Number(value);
    if (isNaN(numValue)) {
      return Promise.reject('Please enter a valid number');
    }
    if (numValue < 0 || numValue > 100) {
      return Promise.reject('Percentage must be between 0 and 100');
    }
    return Promise.resolve();
  };

  return (
    <div>
      <Modal
        open={true}
        footer={null}
        closeIcon={null}
        width="436px"
        onCancel={onCancel}
      >
        <Card>
          <div className="flex">
            <h2 className="flex-1">Edit Yupup’s Cut</h2>
            <img
              src={Close}
              alt="Edit Icon"
              className="w-3.2 hover:cursor-pointer"
              onClick={onCancel}
            />
          </div>
          <Form form={form} onFinish={onFinish}>
            <div className="fex flex-col justify-center">
              <div>
                <p className="text-1.4">Yupup's Cut per Service</p>
                <Input
                  placeholder={"N/A"}
                  disabled
                  defaultValue={`${data?.business?.cutFee >= 0 ? data?.business?.cutFee : 5}%`}
                  className={"w-full h-5.4 !rounded-xl border-unset"}
                />
                <Form.Item name="confirmCut" rules={[
                    { validator: validatePercentage }
                  ]} getValueFromEvent={getNonNegativeFromEvent}>
                  <div>
                    <div>
                      <p className="text-1.4">Update Yupup's Cut</p>
                    </div>
                    <Input
                      type="number"
                      inputMode="decimal"
                      onKeyDown={preventNegativeKey}
                      onPaste={preventNegativePaste}
                      onWheel={(e) => e.currentTarget.blur()}
                      min={0}
                      className="flex items-center w-full h-5.4 bg-white"
                      placeholder="% Yupup's Service Cut"
                    />
                  </div>
                </Form.Item>
              </div>
              <div>
                <p className="text-1.4">Yupup's Cut per Sub-Service</p>
                <Input
                  placeholder={"N/A"}
                  disabled
                  defaultValue={`${data?.business?.subServiceCutFee >= 0 ? data?.business?.subServiceCutFee : 5}%`}
                  className={"w-full h-5.4"}
                />
                <Form.Item name="confirmSubServiceCut" rules={[
                    { validator: validatePercentage }
                  ]} getValueFromEvent={getNonNegativeFromEvent}>
                  <div>
                    <div>
                      <p className="text-1.4">Update Yupup's Cut</p>
                    </div>
                    <Input
                      type="number"
                      inputMode="decimal"
                      onKeyDown={preventNegativeKey}
                      onPaste={preventNegativePaste}
                      onWheel={(e) => e.currentTarget.blur()}
                      min={0}
                      className="flex items-center w-full h-5.4 bg-white"
                      placeholder="% Yupup's Sub-Service Cut"
                    />
                  </div>
                </Form.Item>
              </div>
            </div>
            <Form.Item>
              <Button
                title={"Save"}
                color={colors.primaryPurple}
                htmlType="submit"
                className="flex items-center w-full"
              />
            </Form.Item>
          </Form>
        </Card>
      </Modal>
    </div>
  );
};
export default YupupCutModal;
